
/**
 * 验证两条密码是否一致
 * @param password          @第一条输入的密码
 * @param repeatPassword    @第二条输入的密码
 * @param cb                @iview的表单rule调用的callback函数
 * @returns {*}
 */
export const validEqualPassword = (password, repeatPassword, cb) => {
    if(password && repeatPassword) {
        if(password.length > 0 && repeatPassword.length > 0) {
            if(password !== repeatPassword) {
                return cb(new Error('两次密码不一致'));
            }
        }
    }

    return cb();
};


// WEBPACK FOOTER //
// ./src/resources/utils/validate-utils.js